import React, { useContext } from 'react'
import Product from "@/components/Product"
import { CartContext } from "@/App"

export default function ProductList({ products, onAddToCart }) {
  const {cart} = useContext(CartContext)

	return (
		<div className="flex flex-wrap gap-5 justify-center">
				{products.map(product => (
					<Product
					key={product._id}
					title={product.iName}
					imgSrc={product?.imgPath?.split(";")[0]|| "https://d3o2e4jr3mxnm3.cloudfront.net/Mens-Jake-Guitar-Vintage-Crusher-Tee_68382_1_lg.png"} 
					price={product.tranRate?.toFixed(2)}
					rate={product.rate?.toFixed(2)}
					discountPercent={product.discountPercent}
					link={`/products/${product.itemId}`}
					onAddToCart={() => onAddToCart(product)}
					isInCart={cart?.products?.some(p => p.itemId == product.itemId)}
					/>
				))}
			</div>
	)
}